export default {
  app: {
    name: '\u5168\u7403\u8d38\u6613\u6570\u667a\u5e94\u7528\u5e73\u53f0'
  },
  month: 'Jan | Feb | Mar | Apr | May | Jun | Jul | Aug | Sep | Oct | Nov | Dec',
  dateTime: {
    onlyMonth: '{month}\u6708',
    short: '{year}\u5e74{month}\u6708{day}\u65e5',
    short2: '{year}\u5e74{month}\u6708{day}\u65e5',
    short3: '{year}\u5e74{month}\u6708{day}\u65e5',
    short4: '{year}.{month}.{day}',
    short5: '{year}-{month}-{day}',
    short6: '{year}{month}{day}',
    f1: '{year}.{month}.{day} {hour}:{minute}:{seconds}',
    f2: '{year}\u5e74{month}\u6708{day}\u65e5 {hour}:{minute}:{seconds}',
    f3: '{year}{month}{day}{hour}{minute}{seconds}'
  },
  nav: {
    home: '\u9996\u9875',
    search: '\u67e5\u8be2',
    laws: '\u6cd5\u5f8b\u6cd5\u89c4',
    news: '\u65b0\u95fb\u6d3b\u52a8',
    rcep: 'RCEP\u7ebf\u4e0b\u57f9\u8bad\u4e13\u533a',
    rcepClassRoom: '\u54a8\u8be2\u57f9\u8bad\u670d\u52a1',
    platform: '\u5e73\u53f0\u670d\u52a1',
    zxzj: '\u54a8\u8be2\u4e13\u5bb6',
    manual: '\u4f7f\u7528\u5e2e\u52a9',
    dataBoard: '\u5927\u6570\u636e\u770b\u677f',
    origincert: '\u539f\u4ea7\u5730\u8bc1\u660e\u529e\u7406',
    mobile: '\u79fb\u52a8\u7aef\u52a9\u624b',
    about: '\u79d1\u6a58\u670d\u52a1',
    expertService: '\u4e13\u5bb6\u5e2e\u52a9',
    newService: '\u5e2e\u52a9\u4e2d\u5fc3',
    faq: '\u5e38\u89c1\u95ee\u9898',
    account: '\u8d26\u6237',
    login: '\u767b\u9646',
    register: '\u6ce8\u518c',
    myAccount: '\u6211\u7684\u5e10\u6237',
    myInfo: '\u4e2a\u4eba\u4fe1\u606f',
    setting: '\u5f39\u7a97\u8bbe\u7f6e'
  },
  slogen: {
    title: '\u5168\u7403\u8d38\u6613\u6570\u667a\u5e94\u7528\u5e73\u53f0',
    desc: '\u60a8\u7684\u667a\u80fd\u5173\u52a1\u7ba1\u5bb6'
  },
  smsCounter: '{counter}\u79d2',
  smsFailed: '\u77ed\u4fe1\u53d1\u9001\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5',
  smsError: '\u77ed\u4fe1\u53d1\u9001\u5931\u8d25',
  smsSuccess: '\u9a8c\u8bc1\u7801\u53d1\u9001\u6210\u529f',
  account: {
    setting: {
      title: '\u5f39\u7a97\u8bbe\u7f6e',
      errMsg: '\u5f39\u7a97\u8bbe\u7f6e\u66f4\u65b0\u5931\u8d25',
      codeErrMsg: '\u5f39\u7a97\u8bbe\u7f6e\u66f4\u65b0\u5931\u8d25\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5'
    },
    recharge: {
      title: '\u5e10\u6237\u5145\u503c',
      stateTitle: '\u5145\u503c\u7ed3\u679c',
      historyTitle: '\u5145\u503c\u5386\u53f2'
    },
    integral: {
      title: '\u6211\u7684\u5151\u6362',
      cardCodePlaceholder: '\u8bf7\u8f93\u5165\u5361\u53f7',
      cardCodeMsg: '\u8bf7\u586b\u5199\u5361\u53f7',
      cardCodeNotFound: '\u672a\u627e\u5230\u6b64\u5151\u6362\u5361\u4fe1\u606f'
    },
    invoice: {
      title: '\u6211\u7684\u53d1\u7968',
      amountPlaceholder: '\u53d1\u7968\u91d1\u989d',
      vatPlaceholder: '\u589e\u503c\u7a0e\u7c7b\u578b',
      typePlaceholder: '\u53d1\u7968\u7c7b\u578b',
      titlePlaceholder: '\u53d1\u7968\u62ac\u5934',
      taxNoPlaceholder: '\u7a0e\u53f7',
      addressPlaceholder: '\u53d1\u7968\u5730\u5740',
      mobilePlaceholder: '\u7535\u8bdd\u53f7\u7801',
      bankPlaceholder: '\u5f00\u6237\u884c\u540d\u79f0',
      bankNoPlaceholder: '\u94f6\u884c\u5361\u53f7',
      amountMsg: '\u8bf7\u586b\u5199\u6b63\u786e\u7684\u5f00\u7968\u91d1\u989d',
      vatMsg: '\u8bf7\u9009\u62e9\u589e\u503c\u7a0e\u7c7b\u578b ',
      typeMsg: '\u8bf7\u9009\u62e9\u53d1\u7968\u7c7b\u578b',
      titleMsg: '\u8bf7\u586b\u5199\u53d1\u7968\u62ac\u5934',
      taxNoMsg: '\u8bf7\u586b\u5199\u7a0e\u53f7',
      addressMsg: '\u8bf7\u586b\u5199\u53d1\u7968\u5730\u5740',
      mobileMsg: '\u8bf7\u586b\u5199\u7535\u8bdd\u53f7\u7801',
      bankMsg: '\u8bf7\u586b\u5199\u5f00\u6237\u884c\u540d\u79f0',
      bankNoMsg: '\u8bf7\u586b\u5199\u94f6\u884c\u5361\u53f7'
    },
    login: {
      uidPlaceholder: '\u8bf7\u8f93\u5165\u6709\u6548\u7684\u4f1a\u5458\u540d\u79f0',
      pwdPlaceholder: '\u8bf7\u8f93\u5165\u767b\u5f55\u5bc6\u7801',
      rememberPwd: '\u8bb0\u4f4f\u5bc6\u7801',
      forgotPwd: '\u5fd8\u8bb0\u5bc6\u7801\uff1f',
      noAccount: '\u60a8\u8fd8\u6ca1\u6709\u8d26\u6237\uff1f ',
      regNow: '\u7acb\u5373\u6ce8\u518c',
      loginError: '\u767b\u5f55\u5931\u8d25',
      loginErrorAgain: '\u767b\u5f55\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5',
      userOrPwdError: '\u7528\u6237\u540d\u6216\u5bc6\u7801\u9519\u8bef',
      accountDisable: '\u60a8\u7684\u5e10\u53f7\u5df2\u88ab\u7981\u7528',
      accountAuditing: '\u60a8\u7684\u5e10\u53f7\u6b63\u5728\u5ba1\u6838\u4e2d',
      accountNotActivation: '\u60a8\u7684\u5e10\u6237\u5c1a\u672a\u6fc0\u6d3b'
    },
    reg: {
      uidPlaceholder: '\u4f1a\u5458\u540d',
      uidPlaceholder2: '\u8bf7\u8f93\u5165\u4f1a\u5458\u540d',
      pwdPlaceholder: '\u767b\u5f55\u5bc6\u7801',
      passwordRetry: '\u786e\u8ba4\u5bc6\u7801',
      passwordRetry2: '\u8bf7\u8f93\u5165\u786e\u8ba4\u5bc6\u7801',
      genderPlaceholder: '\u6027\u522b',
      avatarPlaceholder: '\u4f1a\u5458\u5934\u50cf',
      unamePlaceholder: '\u59d3\u540d',
      unamePlaceholder2: '\u8bf7\u8f93\u5165\u59d3\u540d',
      comIndustryPersonPlaceholder: '\u6240\u5728\u4f01\u4e1a\u884c\u4e1a',
      comIndustryPersonPlaceholder2: '\u8bf7\u9009\u62e9\u6240\u5728\u4f01\u4e1a\u884c\u4e1a',
      comIndustryPlaceholder: '\u6240\u5728\u4f01\u4e1a\u884c\u4e1a',
      comIndustryPlaceholder2: '\u8bf7\u9009\u62e9\u6240\u5728\u4f01\u4e1a\u884c\u4e1a',
      comIndustryOtherPlaceholder: '\u8bf7\u8f93\u5165\u6240\u5c5e\u5176\u5b83\u884c\u4e1a',
      comIndustryOtherMsg: '\u8bf7\u586b\u5199\u4f01\u4e1a\u6240\u5c5e\u5176\u5b83\u884c\u4e1a',
      comScopePersonPlaceholder: '\u4f01\u4e1a\u7c7b\u578b',
      comScopePlaceholder: '\u6240\u5728\u4f01\u4e1a\u7c7b\u578b',
      comScopePlaceholder2: '\u8bf7\u9009\u62e9\u6240\u5728\u4f01\u4e1a\u7c7b\u578b',
      comScopePersonPlaceholder2: '\u8bf7\u9009\u62e9\u6240\u5728\u4f01\u4e1a\u7c7b\u578b',
      comScopeOtherPlaceholder: '\u8bf7\u8f93\u5165\u5176\u5b83\u4f01\u4e1a\u7c7b\u578b',
      comScopeOtherMsg: '\u8bf7\u586b\u5199\u4f01\u4e1a\u6240\u5c5e\u7684\u5176\u5b83\u7c7b\u578b',
      comNaturePersonPlaceholder: '\u6240\u5728\u4f01\u4e1a\u6027\u8d28',
      comNaturePersonPlaceholder2: '\u8bf7\u9009\u62e9\u6240\u5728\u4f01\u4e1a\u6027\u8d28',
      comNaturePlaceholder: '\u4f01\u4e1a\u6027\u8d28',
      comNatureOtherPlaceholder: '\u8bf7\u8f93\u5165\u5176\u5b83\u4f01\u4e1a\u6027\u8d28',
      comNatureOtherMsg: '\u8bf7\u586b\u5199\u4f01\u4e1a\u6240\u5c5e\u7684\u5176\u5b83\u6027\u8d28',
      comTradeVolumePlaceholder: '\u4f01\u4e1a\u5e74\u8d38\u6613\u91cf',
      comTradeVolumePlaceholder2: '\u8bf7\u9009\u62e9\u4f01\u4e1a\u5e74\u8d38\u6613\u91cf',
      importAndExportRecordNumber: '\u8fdb\u51fa\u53e3\u5907\u6848\u53f7',
      importAndExportRecordNumber2: '\u8bf7\u8f93\u5165\u8fdb\u51fa\u53e3\u5907\u6848\u53f7',
      recordNumberMsg: '\u8bf7\u586b\u5199\u8fdb\u51fa\u53e3\u5907\u6848\u53f7',
      companyIndustryMsg: '\u8bf7\u9009\u62e9\u4f01\u4e1a\u884c\u4e1a',
      companyNatureMsg: '\u8bf7\u9009\u62e9\u4f01\u4e1a\u6027\u8d28',
      companyTypeMsg: '\u8bf7\u9009\u62e9\u4f01\u4e1a\u7c7b\u578b',
      companyTradeMsg: '\u8bf7\u9009\u62e9\u4f01\u4e1a\u5e74\u8d38\u6613\u91cf',
      emailPlaceholder: '\u90ae\u7bb1\u5730\u5740',
      emailPlaceholder2: '\u8bf7\u8f93\u5165\u90ae\u7bb1\u5730\u5740',
      phonePlaceholder: '\u624b\u673a\u53f7\u7801',
      phonePlaceholder2: '\u8bf7\u8f93\u5165\u624b\u673a\u53f7\u7801',
      authCodePlaceholder: '\u9a8c\u8bc1\u7801',
      authCodePlaceholder2: '\u8bf7\u8f93\u5165\u9a8c\u8bc1\u7801',
      sendAuthCode: '\u53d1\u9001\u9a8c\u8bc1\u7801',
      privacyPlaceholder: '\u8bf7\u9605\u8bfb\u5e76\u52fe\u9009',
      privacyName: '\u670d\u52a1\u534f\u8bae\u53ca\u9690\u79c1\u6743\u653f\u7b56',
      hasAccount: '\u5df2\u7ecf\u62e5\u6709\u8d26\u6237\uff1f',
      loginNow: '\u524d\u53bb\u767b\u5f55',
      passwordRetryMsg: '\u8bf7\u91cd\u65b0\u8f93\u5165\u60a8\u7684\u5bc6\u7801',
      unameMsg: '\u8bf7\u8f93\u5165\u60a8\u7684\u59d3\u540d',
      emailMsg: '\u8bf7\u8f93\u5165\u6709\u6548\u7684\u90ae\u7bb1\u5730\u5740',
      phoneMsg: '\u8bf7\u8f93\u5165\u6709\u6548\u7684\u624b\u673a\u53f7\u7801',
      authCodeMsg: '\u8bf7\u8f93\u5165\u9a8c\u8bc1\u7801',
      privacyMsg: '\u8bf7\u5148\u9605\u8bfb\u5e76\u540c\u610f\u670d\u52a1\u6761\u6b3e',
      personal: '\u4e2a\u4eba\u5e10\u53f7',
      company: '\u4f01\u4e1a\u5e10\u53f7',
      uidExists: '\u7528\u6237\u540d\u5df2\u5b58\u5728',
      uidMinLenMsg: '\u7528\u6237\u540d\u4e0d\u5c11\u4e8e6\u4e2a\u5b57\u7b26',
      pwdMinLenMsg: '\u5bc6\u7801\u4e0d\u5c11\u4e8e6\u4e2a\u5b57\u7b26',
      retryPwdNoMatch: '\u5bc6\u7801\u4e0e\u786e\u8ba4\u5bc6\u7801\u4e0d\u4e00\u81f4',
      regError: '\u6ce8\u518c\u5931\u8d25',
      regErrorAgain: '\u6ce8\u518c\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5',
      regSuccess: '\u6ce8\u518c\u6210\u529f\uff0c\u8bf7\u767b\u5f55',
      authCodeInvalid: '\u9a8c\u8bc1\u7801\u65e0\u6548\u6216\u5df2\u5931\u6548',
      sendEmailInvalid: '\u90ae\u4ef6\u53d1\u9001\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5',
      comLocPersonPlaceholder: '\u4f01\u4e1a\u6240\u5728\u5730\u533a',
      comLocPersonPlaceholder2: '\u8bf7\u8f93\u5165\u4f01\u4e1a\u6240\u5728\u5730\u533a',
      comLocPersonPlaceholder3: '\u8bf7\u8f93\u5165\u4f01\u4e1a\u6240\u5728\u5730\u533a',
      comNamePlaceholder: '\u4f01\u4e1a\u540d\u79f0',
      comNamePersonPlaceholder: '\u6240\u5728\u4f01\u4e1a\u540d\u79f0',
      comNamePersonPlaceholder2: '\u8bf7\u8f93\u5165\u6240\u5728\u4f01\u4e1a\u540d\u79f0',
      comNamePlaceholder2: '\u8bf7\u8f93\u5165\u6709\u6548\u7684\u4f01\u4e1a\u540d\u79f0',
      comNamePlaceholder3: '\u8bf7\u8f93\u5165\u4f01\u4e1a\u540d\u79f0',
      comContactsPlaceholder: '\u8054\u7cfb\u4eba\u59d3\u540d',
      comContactsPlaceholder2: '\u8bf7\u8f93\u5165\u6709\u6548\u7684\u8054\u7cfb\u4eba\u59d3\u540d',
      comContactsPlaceholder3: '\u8bf7\u8f93\u5165\u8054\u7cfb\u4eba\u59d3\u540d',
      comTelPlaceholder: '\u8054\u7cfb\u65b9\u5f0f',
      comTelPlaceholder2: '\u8bf7\u8f93\u5165\u8054\u7cfb\u65b9\u5f0f',
      comTelMsg: '\u8bf7\u586b\u5199\u8054\u7cfb\u65b9\u5f0f',
      comTelMsg2: '\u8bf7\u586b\u5199\u6b63\u786e\u7684\u8054\u7cfb\u65b9\u5f0f',
      comAddressPlaceholder: '\u4f01\u4e1a\u5730\u5740',
      comAddressPlaceholder2: '\u8bf7\u8f93\u5165\u4f01\u4e1a\u5730\u5740',
      comAddressMsg: '\u8bf7\u586b\u5199\u4f01\u4e1a\u5730\u5740',
      comHscodePlaceholder: '\u6d77\u5173\u6ce8\u518c\u7f16\u7801',
      comHscodePlaceholder2: '\u8bf7\u8f93\u5165\u6d77\u5173\u6ce8\u518c\u7f16\u7801',
      comBusinessLicensePlaceholder: '\u7edf\u4e00\u793e\u4f1a\u4fe1\u7528\u4ee3\u7801',
      comBusinessLicensePlaceholder2: '\u8bf7\u8f93\u5165\u6709\u6548\u7684\u7edf\u4e00\u793e\u4f1a\u4fe1\u7528\u4ee3\u7801',
      comBusinessLicensePlaceholder3: '\u8bf7\u8f93\u5165\u7edf\u4e00\u793e\u4f1a\u4fe1\u7528\u4ee3\u7801',
      inviteCodePlaceholder: '\u9080\u8bf7\u7801\uff08\u9009\u586b\uff09',
      inviteCodePlaceholder2: '\u8bf7\u8f93\u5165\u9080\u8bf7\u7801',
      comRolePlaceholder: '\u8d38\u6613\u8eab\u4efd',
      comRolePlaceholder2: '\u8bf7\u9009\u62e9\u8d38\u6613\u8eab\u4efd',
      comBusinessLicenseUrlPlaceholder: '\u8425\u4e1a\u6267\u7167\u4e0a\u4f20',
      comBusinessLicenseUrlRepetPlaceholder: '\u91cd\u65b0\u4e0a\u4f20\u8425\u4e1a\u6267\u7167',
      comBusinessLicenseUrlPlaceholder2: '\u8bf7\u4e0a\u4f20\u8425\u4e1a\u6267\u7167',
      comBusinessLicenseUrlPlaceholder3: '\u8425\u4e1a\u6267\u7167',
      privacyTitle: '\u5168\u7403\u8d38\u6613\u6570\u667a\u5e94\u7528\u5e73\u53f0\u8f6f\u4ef6\u4f7f\u7528\u6761\u6b3e\uff08\u514d\u8d23\u6761\u6b3e\uff09'
    },
    changePwd: {
      title: '\u4fee\u6539\u5bc6\u7801',
      oldPwdPlaceholder: '\u8bf7\u8f93\u5165\u73b0\u6709\u5bc6\u7801',
      newPwdPlaceholder: '\u8bf7\u8f93\u5165\u65b0\u5bc6\u7801',
      newPasswordRetry: '\u8bf7\u786e\u8ba4\u65b0\u5bc6\u7801',
      changeError: '\u5bc6\u7801\u4fee\u6539\u5931\u8d25',
      chkPwdSuccess: '\u5bc6\u7801\u4fee\u6539\u6210\u529f',
      changeErrorAgain: '\u5bc6\u7801\u4fee\u6539\u5931\u8d25\uff0c\u8bf7\u91cd\u8bd5',
      oldPwdError: '\u539f\u5bc6\u7801\u9519\u8bef'
    },
    fotgot: {
      title: '\u5fd8\u8bb0\u5bc6\u7801',
      mobilePlaceholder: '\u8bf7\u8f93\u516511\u4f4d\u624b\u673a\u53f7\u7801',
      authCodePlaceholder: '\u8bf7\u8f93\u5165\u9a8c\u8bc1\u7801',
      chkPwdSuccess: '\u5bc6\u7801\u4fee\u6539\u6210\u529f\uff0c\u8bf7\u767b\u5f55',
      userNoExist: '\u7528\u6237\u4e0d\u5b58\u5728'
    }
  },
  enjoy: {
    title: '\u4eab\u60e0\u5206\u6790'
  },
  query: {
    type: {
      rateI: '\u8fdb\u53e3\u7a0e\u7387',
      rateE: '\u51fa\u53e3\u7a0e\u7387',
      rate_short: '\u8fdb\u53e3\u7a0e\u7387',
      rules: '\u539f\u4ea7\u5730\u89c4\u5219',
      rules_short: '\u539f\u4ea7\u5730\u89c4\u5219',
      hscode: '\u7a0e\u5219\u67e5\u8be2',
      hscode_short: '\u5546\u54c1\u7a0e\u5219'
    },
    export: '\u8d77\u8fd0\u5730',
    import: '\u76ee\u7684\u5730',
    product: '\u5546\u54c1\u7f16\u7801/\u5546\u54c1\u540d\u79f0',
    dropdown: {
      export: {
        frequent: '\u5e38\u7528',
        fta: '\u81ea\u7531\u8d38\u6613\u534f\u5b9a',
        country: '\u5927\u6d32',
        recent: '\u5386\u53f2\u641c\u7d22'
      }
    },
    message: {
      export_error: '\u8bf7\u5c1d\u8bd5\u5176\u4ed6\u5730\u533a\u8fdb\u884c\u641c\u7d22',
      export_empty: '\u8bf7\u9009\u62e9\u8d77\u8fd0\u5730',
      import_error: '\u8bf7\u5c1d\u8bd5\u5176\u4ed6\u5730\u533a\u8fdb\u884c\u641c\u7d22',
      import_empty: '\u8bf7\u9009\u62e9\u76ee\u7684\u5730',
      product_error: '\u7a0e\u53f7\u4e0d\u5b58\u5728\uff0c\u8bf7\u5c1d\u8bd5\u5176\u4ed6\u5546\u54c1\u7f16\u7801\u8fdb\u884c\u641c\u7d22',
      product_empty: '\u8bf7\u9009\u62e9\u5546\u54c1\u7f16\u7801',
      search_none: '\u8bf7\u5c1d\u8bd5\u5176\u4ed6\u5730\u533a\u6216\u5546\u54c1\u7f16\u7801\u8fdb\u884c\u641c\u7d22',
      news_none: '\u8bf7\u5c1d\u8bd5\u5176\u4ed6\u5185\u5bb9\u8fdb\u884c\u641c\u7d22',
      news_empty: '\u8bf7\u8f93\u5165\u5185\u5bb9\u8fdb\u884c\u641c\u7d22',
      notEqu: '\u8d77\u8fd0\u5730\u4e0e\u76ee\u7684\u5730\u4e0d\u80fd\u76f8\u540c',
      search_frequent: '\u60a8\u7684\u67e5\u8be2\u79ef\u70b9\u5df2\u7528\u5b8c\uff0c\u60a8\u53ef\u4ee5\u901a\u8fc7\u5145\u503c\u83b7\u53d6\u66f4\u591a\u5730\u67e5\u8be2\u79ef\u70b9',
      search_perm_limit: '\u8bf7\u767b\u5f55\u540e\u83b7\u5f97\u66f4\u591a\u7684\u67e5\u8be2\u6b21\u6570',
      search_perm_limit2: '\u8bf7\u767b\u5f55\u540e\u67e5\u8be2',
      input_tariff_empty: '\u8bf7\u8f93\u5165\u5546\u54c1\u8fdb\u53e3\u6216\u51fa\u53e3\u7533\u62a5\u7a0e\u53f7',
      input_tariff_error: '\u60a8\u8f93\u5165\u7684\u5546\u54c1\u7f16\u7801\u4e0d\u5728\uff08\u4e2d\u56fd/\u7f8e\u56fd\uff09\u52a0\u5f81\u8303\u56f4\u5185\u6216\u5546\u54c1\u7f16\u7801\u4e0d\u5b58\u5728',
      input_tariff_iorrect: '\u8bf7\u8f93\u5165\u6b63\u786e\u7684\u5546\u54c1\u8fdb\u53e3/\u51fa\u53e3\u7533\u62a5\u7a0e\u53f7'
    },
    empty: '\u65e0\u5339\u914d\u7ed3\u679c',
    result: {
      rate: {
        breadcrumbs: '\u4ece <span>{from}</span> \u5230 <span>{to}</span> \u8fdb\u53e3 <span>{product}</span>',
        compare: {
          title: '\u5173\u7a0e\u7a0e\u7387\u6bd4\u8f83',
          gtr: '\u666e\u901a\u7a0e\u7387',
          mfn: '\u6700\u60e0\u56fd\u7a0e\u7387',
          ifr: '\u6682\u5b9a\u7a0e\u7387',
          queryRules: 'FTA\u9002\u7528\u89c4\u5219 >'
        },
        recommend: {
          title: '\u6765\u81ea\u5176\u4ed6\u8d77\u8fd0\u5730\u7684\u66f4\u4f4eFTA\u7a0e\u7387\uff1a',
          from: '\u4ece <span>{from}</span> \u5230 <span>{to}</span>',
          saveup: '\u8282\u7701'
        },
        related: {
          title: '\u76f8\u5173\u7a0e\u7387',
          avtr: '\u589e\u503c\u7a0e\u7387',
          adtr: '\u53cd\u503e\u9500\u7a0e\u7387',
          ctr: '\u6d88\u8d39\u7a0e\u7387',
          astr: '\u53cd\u8865\u8d34\u7a0e\u7387'
        },
        es: {
          title: '\u8282\u7a0e\u989d\u4f30\u7b97',
          tb: {
            col1: '\u5173\u7a0e\u91d1\u989d',
            col2: '\u8282\u7701\u5173\u7a0e',
            col3: '\u589e\u503c\u7a0e\u91d1\u989d',
            col4: '\u8282\u7701\u589e\u503c\u7a0e',
            col5: '\u8282\u7a0e\u603b\u989d'
          }
        },
        chart: {
          x1: '\u5173\u7a0e\u91d1\u989d',
          x2: '\u5173\u7a0e+\u589e\u503c\u7a0e'
        },
        summary: {
          title: '\u4ee5 {amount} \u5143\u8fdb\u53e3\u8d27\u7269\u4e3a\u4f8b',
          cal: '\u6211\u8981\u8bd5\u7b97'
        },
        try: '\u6211\u8981\u8bd5\u7b97\u8282\u7a0e\u91d1\u989d',
        tryPlaceholder: '\u8bf7\u8f93\u5165\u8d27\u7269\u4ef7\u503c',
        tryCorrectGoodsValue: '\u8bf7\u8f93\u5165\u6b63\u786e\u7684\u8d27\u7269\u4ef7\u503c',
        nofta: '\u6682\u65e0\u534f\u5b9a\u7a0e\u7387'
      },
      rules: {
        breadcrumbs: '\u4ece <span>{from}</span> \u5230 <span>{to}</span> \u8fdb\u53e3 <span>{product}</span>',
        origin: {
          title: '\u539f\u4ea7\u5730\u6807\u51c6',
          desc: '\u6ee1\u8db3\u4ee5\u4e0b\u6807\u51c6\u4e4b\u4e00\u5373\u53ef'
        },
        addition: {
          title: '\u9644\u52a0\u89c4\u5219'
        },
        transport: {
          title: '\u8fd0\u8f93\u89c4\u5219'
        },
        doc: {
          title: '\u9700\u63d0\u4ea4\u5355\u8bc1'
        },
        noRules: '\u6682\u65e0\u89c4\u5219'
      },
      hscode: {
        trade: {
          title: '\u6240\u9700\u8d38\u6613\u8bb8\u53ef',
          code: '\u76d1\u7ba1\u8bc1\u4ef6\u4ee3\u7801',
          category: '\u68c0\u9a8c\u68c0\u75ab\u7c7b\u522b'
        },
        tax: {
          title: '\u76f8\u5173\u8fdb\u53e3\u7a0e\u7387',
          edr: 'Excise Duty Rate',
          gst: 'GST / VAT',
          customCaption: '\u8fdb\u53e3\u5173\u7a0e',
          otherCaption: '\u5176\u4ed6\u7a0e\u7387\u4fe1\u606f',
          grate: '\u666e\u901a\u5173\u7a0e',
          mtrate: '\u6700\u60e0\u56fd\u7a0e\u7387',
          ptrate: '\u6682\u5b9a\u7a0e\u7387',
          atrate: '\u589e\u503c\u7a0e\u7387',
          ctrate: '\u6d88\u8d39\u7a0e\u7387',
          adtrate: '\u53cd\u503e\u9500\u7a0e\u7387'
        },
        related: {
          title: '\u76f8\u5173\u51fa\u53e3\u7a0e\u7387',
          er: '\u51fa\u53e3\u7a0e\u7387',
          err: '\u51fa\u53e3\u9000\u7a0e\u7387',
          epr: '\u51fa\u53e3\u6682\u5b9a\u7a0e\u7387'
        }
      },
      other: {
        seeftaofproduct: '\u67e5\u770b\u8be5\u5546\u54c1\u7684\u76f8\u5173\u7a0e\u7387\u4fe1\u606f',
        codeDictQuery: '\u7f16\u7801\u5b57\u5178\u67e5\u8be2',
        ciqHSQuery: '13\u4f4d\u5546\u54c1\u7f16\u7801\u67e5\u8be2',
        zmAddTariffQuery: '\u4e2d\u7f8e\u52a0\u5f81\u901f\u67e5',
        policy: '\u76f8\u5173\u653f\u7b56',
        more: '\u66f4\u591a >',
        news: '\u76f8\u5173\u65b0\u95fb',
        otherFta: '\u76f8\u540c\u5546\u54c1\u7684\u5176\u4ed6FTA\u7a0e\u7387',
        otherRules: '\u76f8\u540c\u5546\u54c1\u7684\u5176\u4ed6\u539f\u4ea7\u5730\u89c4\u5219',
        fta: 'FTA',
        mfn: '\u6700\u60e0\u56fd\u7a0e\u7387',
        goodsValue: '\u8d27\u503c'
      }
    }
  },
  rulesDecide: {
    title: '\u539f\u4ea7\u5730\u5224\u5b9a\u67e5\u8be2',
    title2: '\u539f\u4ea7\u5730\u5386\u53f2\u5224\u5b9a\u67e5\u8be2',
    invoice: {
      title: '\u53d1\u7968\u660e\u7ec6'
    }
  },
  btn: {
    search: '\u67e5\u8be2',
    reset: '\u91cd\u7f6e',
    cancel: '\u53d6\u6d88',
    confirm: '\u786e\u5b9a',
    confirmed: '\u786e\u5b9a',
    loginin: '\u767b\u5f55',
    signup: '\u6ce8\u518c',
    submit: '\u63d0\u4ea4',
    next: '\u4e0b\u4e00\u6b65',
    back: '\u4e0a\u4e00\u6b65',
    backHome: '\u8fd4\u56de',
    close: '\u5173\u95ed'
  },
  advantage: {
    title: '\u5168\u7403\u8d38\u6613\u6570\u667a\u5e94\u7528\u5e73\u53f0',
    desc: {
      p1: '\u534f\u52a9\u4f60\u4e86\u89e3\u5c06\u8981\u8fdb\u51fa\u53e3\u5546\u54c1\u7684\u6700\u4f4e\u5173\u7a0e\u7a0e\u7387\uff0c\u63d0\u524d\u8fdb\u884c\u5173\u7a0e\u7b79\u5212',
      p2: '\u534f\u52a9\u4f60\u51c6\u5907\u539f\u4ea7\u5730\u8bc1\u4e66\u7684\u7533\u8bf7\u6587\u4ef6\uff0c\u4eab\u53d7\u6700\u4f4e\u5173\u7a0e\u4f18\u60e0\u5f85\u9047',
      p3: '\u534f\u52a9\u4f60\u8fdb\u884c\u8fdb\u51fa\u53e3\u5546\u54c1\u7ba1\u7406\uff0c\u5408\u6cd5\u5408\u89c4\u63d0\u9ad8\u8d38\u6613\u6548\u7387'
    },
    step: {
      one: {
        title: '\u4e00\u7ad9\u5f0f\u67e5\u8be2',
        desc: '\u53ef\u4ee5\u5feb\u6377\u67e5\u8be2\u5546\u54c1\u6240\u5bf9\u5e94\u7684\u534f\u5b9a\u7a0e\u7387\u3001HS\u6d77\u5173\u7f16\u7801\u3001\u539f\u4ea7\u5730\u6807\u51c6\u7b49'
      },
      two: {
        title: '\u6700\u4f18\u63a8\u8350',
        desc: '\u6839\u636e\u6240\u67e5\u8be2\u5546\u54c1\u7a0e\u53f7\uff0c\u63a8\u8350\u53ef\u4eab\u53d7\u7684\u6700\u4f4e\u7a0e\u7387\u5f85\u9047\u53ca\u539f\u4ea7\u5730\u65b9\u6848'
      },
      three: {
        title: '\u4e13\u5bb6\u5e94\u7b54',
        desc: '\u5f3a\u5927\u7684\u4e13\u5bb6\u56e2\u961f\u8fdb\u884c\u5728\u7ebf\u5e94\u7b54\uff0c\u9488\u5bf9\u4e13\u4e1a\u95ee\u9898\u63d0\u4f9b\u53ca\u65f6\u7b54\u7591\u4e0e\u89c4\u5219\u89e3\u8bfb'
      }
    }
  },
  lawsRules: {
    title: '\u6cd5\u5f8b\u6cd5\u89c4'
  },
  newsActivity: {
    title: '\u65b0\u95fb\u6d3b\u52a8',
    searchPlaceholder: '\u8bf7\u8f93\u5165\u5185\u5bb9\u8fdb\u884c\u641c\u7d22',
    classify: '\u5206\u7c7b',
    datePlaceholder: '\u8bf7\u9009\u62e9\u65e5\u671f'
  },
  faq: {
    title: '\u5e38\u89c1\u95ee\u9898',
    q: '',
    a: ''
  },
  codeQuery: {
    tb: {
      col1: '\u5546\u54c1\u7f16\u7801',
      col2: '\u5546\u54c1\u540d\u79f0'
    }
  },
  ciqQuery: {
    hsPlaceholder: 'HS\u7f16\u7801',
    ciqPlaceholder: '13\u4f4d\u5546\u54c1\u7f16\u7801',
    tb: {
      col1: 'HS\u7f16\u7801',
      col2: 'HS\u7f16\u7801\u540d\u79f0',
      col3: '13\u4f4d\u5546\u54c1\u7f16\u7801',
      col4: '13\u4f4d\u5546\u54c1\u7f16\u7801\u540d\u79f0'
    }
  },
  aboutus: {
    title: '\u7ebf\u4e0a\u670d\u52a1\u5185\u5bb9\u7b80\u4ecb',
    title2: '\u7ebf\u4e0b\u670d\u52a1\u5185\u5bb9\u7b80\u4ecb'
  },
  footer: {
    friendship: '\u53cb\u60c5\u94fe\u63a5',
    contact: '\u8054\u7cfb\u6211\u4eec',
    share: '\u5206\u4eab\u5230',
    goTip: '\u8bf7\u8f93\u5165\u6709\u6548\u7684\u5e10\u53f7\u4fe1\u606f',
    goName: 'GO!',
    copyright: 'Copyright \xa9 \u4e0a\u6d77\u79d1\u6a58\u4fe1\u606f\u79d1\u6280\u6709\u9650\u516c\u53f8  \u6caaICP\u590719035327\u53f7-1'
  },
  common: {
    share: '\u5206\u4eab',
    date: '\u65e5\u671f',
    today: '\u4eca\u65e5',
    yesterday: '\u6628\u65e5',
    lastWeek: '\u4e0a\u5468',
    laseMonth: '\u4e0a\u6708',
    hot: 'HOT',
    new: 'NEW',
    before: '\u4e0a\u4e00\u6761',
    next: '\u4e0b\u4e00\u6761',
    nodata: '\u65e0\u6570\u636e',
    tryAgain: '\u7f51\u7edc\u7e41\u5fd9\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5',
    codeError: '\u8fd4\u56de\u7801\u9519\u8bef\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5',
    loading: '\u52a0\u8f7d\u4e2d...',
    noResult: '\u65e0\u7ed3\u679c',
    allCate: '\u5168\u90e8',
    allDate: '\u5168\u90e8',
    readmore: '\u67e5\u770b\u8be6\u60c5',
    tariffs: '\u5173\u7a0e',
    frequent: '\u60a8\u7684\u64cd\u4f5c\u8fc7\u4e8e\u9891\u7e41\uff0c\u8bf7\u7a0d\u5019\u518d\u8bd5',
    uploading: '\u4e0a\u4f20\u4e2d',
    uploadSasError: '\u83b7\u53d6Token\u9519\u8bef',
    uploadSasError2: '\u83b7\u53d6Token\u9519\u8bef\uff0c\u8bf7\u7a0d\u5019\u518d\u8bd5',
    uploadTypeError: '\u4e0a\u4f20\u6587\u4ef6\u7c7b\u578b\u9519\u8bef\uff0c\u8bf7\u4e0a\u4f20\u56fe\u7247\u6587\u4ef6',
    uploadSizeError: '\u4e0a\u4f20\u6587\u4ef6\u8fc7\u5927\uff0c\u8bf7\u4e0a\u4f20\u4e0d\u8d85\u8fc720M\u7684\u6587\u4ef6',
    uploadError: '\u6587\u4ef6\u4e0a\u4f20\u5931\u8d25',
    preview: '\u9884\u89c8\u56fe\u7247',
    sendmail: '\u90ae\u4ef6\u53d1\u9001\u4e2d...',
    cpwd: '\u4fee\u6539\u5bc6\u7801',
    logout: '\u9000\u51fa'
  },
  notfound: '\u672a\u627e\u5230\u8be5\u9875\u9762',
  notfoundMsg: '\u5f53\u524d\u9875\u9762\u8d70\u4e22\u4e86...',
  websiteDesc: '\u5168\u7403\u8d38\u6613\u6570\u667a\u5e94\u7528\u5e73\u53f0\u7cfb\u7edf\u65e8\u5728\u4e3a\u4f01\u4e1a\u5c24\u5176\u662f\u4e2d\u5c0f\u4f01\u4e1a\u89e3\u51b3FTA\u4f18\u60e0\u5173\u7a0e\u7684\u4fe1\u606f\u67e5\u8be2\u53ca\u5e94\u7528\u95ee\u9898\u3002\u901a\u8fc7\u8be5\u7cfb\u7edf\uff0c\u4f01\u4e1a\u53ef\u4ee5\u7b80\u6613\u5feb\u6377\u5730\u4e86\u89e3\u5230\u54ea\u4e9b\u8fdb\u51fa\u53e3\u5546\u54c1\u53ef\u4ee5\u4eab\u53d7\u96f6\u5173\u7a0e\uff0c\u4ee5\u53ca\u5982\u4f55\u4eab\u53d7\u96f6\u5173\u7a0e\uff0c\u63d0\u9ad8\u4f01\u4e1a\u5728FTA\u4f18\u60e0\u5173\u7a0e\u65b9\u9762\u7684\u5229\u7528\u80fd\u529b\u3002'
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh-CN.js